import React, { useEffect, useState } from 'react'
import FetchAllCategoryAndSubCategoryService from '../../../../../../Service/DashboardServices/AssetGalleryServices/FetchAllCategoryAndSubCategoryService';
import { connect } from "react-redux";
import ProductDetails from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/ProductDetails';
// import ProductDetails from '../../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v1/Components/ProductDetails';

function ProjectsDashProductsMainPage(props) {
  const [assetsCategoryID,setAssetsCategoryID]=useState()
  const [assetsSubCategory,setAssetsSubCategory]=useState()
  useEffect(()=>{
    console.log(props.selectedProjectData);
    let data = {
      integerId: props.selectedProjectData.integerId,
      assetIdentifier:''
    };
    FetchAllCategoryAndSubCategoryService(props.token,data).then((response)=>{
      if(response){
        console.log(response);
        setAssetsCategoryID(response.category)
        setAssetsSubCategory(response.subCategory)
      }
    })
  },[])
  return (
    <div className="ml-3 mt-3">
    <ProductDetails
    subCategory={assetsSubCategory} catId={2}
    selectedProjectData={props.selectedProjectData}
    UserPermission={props.projectPermissions}
    />
    
    </div>
  )
}
const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
  UserPermission: state.accountOverview.store.StoreUserPermission,
});

export default connect(mapStateToProps)(ProjectsDashProductsMainPage);
